import _ from 'lodash';

import type { Cart, CartRow } from 'domain-model/types/pcs';

interface PersistedMultiCartState {
  cartUpdateMessage: string;
  cartUpdateErrorMessages: string[];
  carts: {
    [key: string]: Cart;
  };
}

const BASE_ERROR_MESSAGE =
  'Varukorgen har hamnat ur sync. Var god uppdatera sidan.';

export function handleCartRowInsertion(
  state: PersistedMultiCartState,
  cartId: string,
  rowToInsert: any,
) {
  // in each cart there is an id. This id is the same as the cartId

  const cartKey = _.findKey(state.carts, (cart: Cart) => cart.id === cartId);

  if (!cartKey) {
    state.cartUpdateErrorMessages.push(
      `${BASE_ERROR_MESSAGE} (Tekniskt: kunde inte hitta cartId ${cartId})`,
    );
    return state;
  }

  const cart = state.carts[cartKey];

  if (!cart) {
    state.cartUpdateErrorMessages.push(
      `${BASE_ERROR_MESSAGE} (Tekniskt: kunde inte hitta cartId ${cartId})`,
    );
    return state;
  }

  // find row based on pricedArticleId and when it exists also procurementArticleId
  const resultingCartRows = [...cart.cartRows];
  const cartRowIndex = resultingCartRows.findIndex((oldCartRow: CartRow) => {
    if (rowToInsert.procurementArticle?.id) {
      return (
        oldCartRow.procurementArticle?.id === rowToInsert.procurementArticle.id
      );
    }
    if (!rowToInsert.procurementArticle && rowToInsert.pricedArticle?.id) {
      return (
        !oldCartRow.procurementArticle &&
        // @ts-ignore
        oldCartRow.pricedArticle.id === rowToInsert.pricedArticle.id
      );
    }
    return false;
  });

  if (cartRowIndex !== -1) {
    resultingCartRows[cartRowIndex]!.id = rowToInsert.id;
  } else {
    // resultingCartRows.push(rowToInsert);
    resultingCartRows.push(rowToInsert);
  }
  return {
    ...state,
    carts: {
      ...state.carts,
      [cartKey]: { ...cart, cartRows: resultingCartRows },
    },
  };
}

export function handleCartRowUpdate(
  state: PersistedMultiCartState,
  rowToUpdate: any,
  isItMe: boolean,
) {
  const { id, quantity, orderedSKU, orderUnit } = rowToUpdate;

  const carts = state.carts;
  let foundRow = false;

  const updatedCarts = { ...carts };
  Object.keys(carts).forEach(cartKey => {
    const cart: Cart = carts[cartKey]!;
    const cartRows = cart?.cartRows || [];
    const cartRowIndex = cartRows.findIndex((row: CartRow) => row.id === id);
    if (cartRowIndex !== -1) {
      foundRow = true;
      if (quantity !== undefined) {
        cartRows[cartRowIndex]!.quantity = quantity;
      }
      if (orderedSKU !== undefined) {
        cartRows[cartRowIndex]!.orderedSKU = orderedSKU;
      }
      if (orderUnit !== undefined) {
        cartRows[cartRowIndex]!.orderUnit = orderUnit;
      }
    }
    updatedCarts[cartKey] = { ...cart, cartRows };
  });

  if (!foundRow && !isItMe) {
    state.cartUpdateErrorMessages.push(
      `${BASE_ERROR_MESSAGE} (Tekniskt: Kunde inte hitta cartRowId ${id}) `,
    );
  }
  return {
    ...state,
    carts: _.cloneDeep(updatedCarts),
  };
}

export function handleCartRowDeletion(
  state: PersistedMultiCartState,
  rowToDelete: any,
  isItMe: boolean,
) {
  const { id } = rowToDelete;

  const carts = state.carts;
  let foundRow = false;

  const updatedCarts = { ...carts };
  Object.keys(carts).forEach(cartKey => {
    const cart: Cart = carts[cartKey]!;
    const cartRows = cart.cartRows;
    const cartRowIndex = cartRows.findIndex((row: CartRow) => row.id === id);
    if (cartRowIndex !== -1) {
      foundRow = true;
      cartRows.splice(cartRowIndex, 1);
      updatedCarts[cartKey] = { ...cart, cartRows };
    }
  });
  if (!foundRow && !isItMe) {
    state.cartUpdateErrorMessages.push(
      `${BASE_ERROR_MESSAGE} 'Tekniskt: Kunde inte hitta cartRowId ${id})`,
    );
    return state;
  }
  return {
    ...state,
    carts: updatedCarts,
  };
}
